import React from "react";
import ProjectLayout from "../layouts/ProjectLayout";
import projectsData from "../data/projectsData";

const Safdarjung = () => {
  const data = projectsData.safdarjungDelhi;
  return <ProjectLayout {...data} />;
};

export default Safdarjung;
